import React from "react";
import usePageMetadata from "@/lib/usePageMetadata";
import HeroSection from "./ui/HeroSection";
import AboutSection from "./ui/AboutSection";
import BlogsSection from "./ui/BlogsSection";
import Testimonials from "./ui/Testimonials";
import ServicesSection from "./ui/ServicesSection";
import WorkshopsSection from "./ui/WorkshopsSection";

function Home() {
  usePageMetadata(
    "Home | BioStat",
    "Welcome to BioStat, your partner in biostatistics and data analysis. We specialize in providing insights and solutions for healthcare research. Explore our services, projects, and client success stories.",
  );

  return (
    <div className="relative">
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <Testimonials />
      <WorkshopsSection />
      <BlogsSection />
    </div>
  );
}

export default Home;
